import uploadslocationpagebannerbgimagelocationBannerJpg from "$lib/data/generated/uploads/location/PageBanner/bgImage/Location Banner.jpg";

export const uploads = {
  "uploads/location/PageBanner/bgImage/Location Banner.jpg": uploadslocationpagebannerbgimagelocationBannerJpg
};